import React, { useEffect } from 'react';

// images
import userImg from '../../assets/img/user-profile.png';
import UserGroup from '../../models/userGroup.model';
import { Users } from '../../models/users.model';

export default function Profile() {
    const user = JSON.parse(localStorage.getItem('currentUsr')!);
    const [infra2User, setInfra2User] = React.useState<Users>();
    const [userGroups, setUserGroups] = React.useState<UserGroup[]>([]);
    useEffect(() => {
        if (user && localStorage.getItem('Roles') && localStorage.getItem('Infra2_User')) {
            const infra2_User = JSON.parse(localStorage.getItem('Infra2_User') as string);
            const ug = JSON.parse(localStorage.getItem('Roles') as string);
            setInfra2User(infra2_User);
            setUserGroups(ug);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <section id='profile'>
            <h3>Mi perfil</h3>
            <div className='content'>
                {infra2User && (
                    <div className='row'>
                        <div className='image-profile'>
                            <img src={userImg} alt='' className='w-75' />
                        </div>
                        <div className='container-data'>
                            <div className='profile-data'>
                                <h5>Nombre</h5>
                                <p>{infra2User.name}</p>
                            </div>
                            <div className='profile-data'>
                                <h5>Pais</h5>
                                <p>
                                    {infra2User.countriesUser?.map((s) => s.countryName).join(', ')}
                                </p>
                            </div>
                            <div className='profile-data'>
                                <h5>Correo</h5>
                                <p>{infra2User.username}</p>
                            </div>
                            <div className='profile-data'>
                                <h5>Roles</h5>
                                <p>{userGroups ? userGroups.map((p) => p.Name).join(', ') : ''}</p>
                            </div>
                            <div className='profile-data'>
                                <h5>Programas Asignados</h5>
                                <p>
                                    {infra2User.programsUser?.map((s) => s.programName).join(', ')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
